import storage from 'redux-persist/lib/storage'
import {ReduxReducerPersistConfig} from '../../lib/redux/ReduxReducer'
import {ReduxSyncOptions} from '../../lib/redux/ReduxMiddleware'

export const REDUX_PERSIST_CONFIG: ReduxReducerPersistConfig = {
  key: 'root',
  storage,
  whitelist: [
    'user',
    'lastUserState',
    'lastTreeState',
    'lastUploadStatePhoto',
    'lastUploadStateVideo',
    'userBanStatus',
    'exploreFilter',
    'verificationStatus',
    'userNewPhone',
    'userNewEmail',
    'hostState',
    'bannerClosed',
    'hostRegistrationState',
    'lastPasswordOTPTime',
    'yuserActivationState',
    'messageRoomState',
    'messageFilterOlderState',
    'forgotPasswordState',
    'similarAccountStatus',
    'roboyuSensitivityLevel',
    'giftshopState',
    'giftShopTooltipState',
    'languageState',
    'easySignupDuplicateState',
    'easySignupState',
    'userDevice',
    'parentalConsentState',
    'exploreMonthPaginationState',
    'findFriendState',
    'forkygramHomefeedsState',
    'searchCreationState',
    'roboyuState',
    'editProfileState',
    'settingState',
  ],
}

export const REDUX_STATE_SYNC_CONFIG: ReduxSyncOptions = {
  whitelist: ['user', 'lastUserState'],
}
